import { render, staticRenderFns } from "./VirtualUserTable.vue?vue&type=template&id=6ebac3ee&"
import script from "./VirtualUserTable.vue?vue&type=script&lang=js&"
export * from "./VirtualUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports